import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addReactionRequest = {};
var _addReactionResponse = {};
var _createPostRequest = { post: '_post' };
var _createPostResponse = { post: '_post' };
var _deletePostRequest = {};
var _deletePostResponse = { post: '_post' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _markPostReadRequest = {};
var _markPostReadResponse = {};
var _markPostsSeenRequest = {};
var _markPostsSeenResponse = {};
var _markPostUnreadRequest = {};
var _markPostUnreadResponse = {};
var _pinPostRequest = {};
var _pinPostResponse = {};
var _post = {
    createdDate: 'google.protobuf.Timestamp',
    lastActivityDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    images: '_image',
    videos: '_videoV2',
};
var _postRequest = {};
var _postResponse = { post: '_post' };
var _postSlugRequest = {};
var _queryPostsRequest = {};
var _queryPostsResponse = { posts: '_post' };
var _removeBestAnswerRequest = {};
var _removeBestAnswerResponse = {};
var _removeReactionRequest = {};
var _removeReactionResponse = {};
var _reportPostRequest = {};
var _reportPostResponse = {};
var _setBestAnswerRequest = {};
var _setBestAnswerResponse = {};
var _unpinPostRequest = {};
var _unpinPostResponse = {};
var _updatePostRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    post: '_post',
};
var _updatePostResponse = { post: '_post' };
var _videoResolution = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    poster: '_image',
};
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_image',
};
var _viewPostRequest = {};
var _viewPostResponse = {};
function resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/_internal/communities',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/communities-forum-app',
                destPath: '',
            },
            {
                srcPath: '/communities',
                destPath: '',
            },
            {
                srcPath: '/_api/',
                destPath: '/_api',
            },
        ],
        'forums.wixapps.net': [
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
            {
                srcPath: '/_api/communities/platformized/v1',
                destPath: '/v1',
            },
        ],
        'forums._base_domain_': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/forum/v1/draft-posts',
                destPath: '/v1/draft-posts',
            },
            {
                srcPath: '/forum/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/forum/v1/comments',
                destPath: '/v1/comments',
            },
            {
                srcPath: '/forum/v1/posts',
                destPath: '/v1/posts',
            },
        ],
        _: [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
            {
                srcPath: '/_api/communities-forum-app',
                destPath: '/_api',
            },
            {
                srcPath: '/_api/communities/forums/this',
                destPath: '/_api/forums/this',
            },
            {
                srcPath: '/_api/communities/categories',
                destPath: '/_api/categories',
            },
            {
                srcPath: '/_api/communities/posts',
                destPath: '/_api/posts',
            },
            {
                srcPath: '/_api/communities/platformized/v1/draft-posts',
                destPath: '/v1/draft-posts',
            },
            {
                srcPath: '/_api/communities/platformized/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/communities/platformized/v1/comments',
                destPath: '/v1/comments',
            },
            {
                srcPath: '/_api/communities/platformized/v1/posts',
                destPath: '/v1/posts',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
            {
                srcPath: '/_api/communities/platformized/v1',
                destPath: '/v1',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
            {
                srcPath: '/_api/communities/platformized/v1',
                destPath: '/v1',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
            {
                srcPath: '/_api/communities/platformized/v1',
                destPath: '/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
            {
                srcPath: '/_api/communities/platformized/v1',
                destPath: '/v1',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
            {
                srcPath: '/_api/communities/platformized/v1',
                destPath: '/v1',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
        ],
        'notifications-app.wixapps.net': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/forum/v1/notifications',
                destPath: '/v1/notifications',
            },
            {
                srcPath: '/forum/v1/draft-posts',
                destPath: '/v1/draft-posts',
            },
            {
                srcPath: '/forum/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/forum/v1/comments',
                destPath: '/v1/comments',
            },
            {
                srcPath: '/forum/v1/posts',
                destPath: '/v1/posts',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a single post by ID. */
export function getPost(payload) {
    var _a = serializer(_postRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_postResponse, {
        _image: _image,
        _post: _post,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __getPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.post',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.forum.api.PostManagementService.GetPost',
            url: resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl({
                protoPath: '/v1/posts/{postId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPost.fromReq = fromReq;
    __getPost.__isAmbassador = true;
    return __getPost;
}
/** Retrieves a single post by URL slug. */
export function getPostBySlug(payload) {
    var _a = serializer(_postSlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_postResponse, {
        _image: _image,
        _post: _post,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __getPostBySlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.post',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.forum.api.PostManagementService.GetPostBySlug',
            url: resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl({
                protoPath: '/v1/posts/slugs/{slug}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPostBySlug.fromReq = fromReq;
    __getPostBySlug.__isAmbassador = true;
    return __getPostBySlug;
}
/**
 * Returns a list of posts by query.
 *
 * Paging
 * - limit: default - 10, min - 0, max - 100
 * - offset: default - 0, min - 0
 *
 * Filterable fields:
 * - id
 * - categoryId
 * - ownerId
 * - title
 * - contentText
 * - bestAnswerCommentId
 * - pinned
 * - commentingEnabled
 * - commentCount
 * - likeCount
 * - viewCount
 * - createdDate
 * - editedDate
 * - lastActivityDate
 * - slug
 *
 * Sortable fields:
 * - lastActivityDate
 * - createdDate
 * - commentCount
 * - viewCount
 * - likeCount
 * - pinned
 */
export function queryPosts(payload) {
    var _a = serializer(_queryPostsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryPostsResponse, {
        _image: _image,
        _post: _post,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __queryPosts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.post',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.forum.api.PostManagementService.QueryPosts',
            url: resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl({
                protoPath: '/v1/posts/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryPosts.fromReq = fromReq;
    __queryPosts.__isAmbassador = true;
    return __queryPosts;
}
/** Increments postViewCount of the post. */
export function viewPost(payload) {
    var _a = serializer(_viewPostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_viewPostResponse, {}).fromJSON;
    function __viewPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.post',
            method: 'PUT',
            methodFqn: 'com.wixpress.npm.communities.forum.api.PostManagementService.ViewPost',
            url: resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl({
                protoPath: '/v1/posts/{postId}/view',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __viewPost.fromReq = fromReq;
    __viewPost.__isAmbassador = true;
    return __viewPost;
}
/** Marks post as read for identity who made a request. */
export function markPostRead(payload) {
    var _a = serializer(_markPostReadRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markPostReadResponse, {}).fromJSON;
    function __markPostRead(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.post',
            method: 'PUT',
            methodFqn: 'com.wixpress.npm.communities.forum.api.PostManagementService.MarkPostRead',
            url: resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl({
                protoPath: '/v1/posts/{postId}/mark-read',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markPostRead.fromReq = fromReq;
    __markPostRead.__isAmbassador = true;
    return __markPostRead;
}
/** Marks posts as seen for identity who made a request. */
export function markPostsSeen(payload) {
    var _a = serializer(_markPostsSeenRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markPostsSeenResponse, {}).fromJSON;
    function __markPostsSeen(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.post',
            method: 'PUT',
            methodFqn: 'com.wixpress.npm.communities.forum.api.PostManagementService.MarkPostsSeen',
            url: resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl({
                protoPath: '/v1/posts/batch/mark-seen',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markPostsSeen.fromReq = fromReq;
    __markPostsSeen.__isAmbassador = true;
    return __markPostsSeen;
}
/** Marks post as unread for identity who made a request. */
export function markPostUnread(payload) {
    var _a = serializer(_markPostUnreadRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markPostUnreadResponse, {}).fromJSON;
    function __markPostUnread(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.post',
            method: 'PUT',
            methodFqn: 'com.wixpress.npm.communities.forum.api.PostManagementService.MarkPostUnread',
            url: resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl({
                protoPath: '/v1/posts/{postId}/mark-unread',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markPostUnread.fromReq = fromReq;
    __markPostUnread.__isAmbassador = true;
    return __markPostUnread;
}
/** Creates a new post. */
export function createPost(payload) {
    var _a = serializer(_createPostRequest, {
        _image: _image,
        _post: _post,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createPostResponse, {
        _image: _image,
        _post: _post,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __createPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.post',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.forum.api.PostManagementService.CreatePost',
            url: resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl({
                protoPath: '/v1/posts',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createPost.fromReq = fromReq;
    __createPost.__isAmbassador = true;
    return __createPost;
}
/** Updates post fields according to `fieldMask`. */
export function updatePost(payload) {
    var _a = serializer(_updatePostRequest, {
        _image: _image,
        _post: _post,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updatePostResponse, {
        _image: _image,
        _post: _post,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __updatePost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.post',
            method: 'PATCH',
            methodFqn: 'com.wixpress.npm.communities.forum.api.PostManagementService.UpdatePost',
            url: resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl({
                protoPath: '/v1/posts/{postId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updatePost.fromReq = fromReq;
    __updatePost.__isAmbassador = true;
    return __updatePost;
}
/** Deletes a post. */
export function deletePost(payload) {
    var _a = serializer(_deletePostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deletePostResponse, {
        _image: _image,
        _post: _post,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __deletePost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.post',
            method: 'DELETE',
            methodFqn: 'com.wixpress.npm.communities.forum.api.PostManagementService.DeletePost',
            url: resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl({
                protoPath: '/v1/posts/{postId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deletePost.fromReq = fromReq;
    __deletePost.__isAmbassador = true;
    return __deletePost;
}
/** Sets the "best answer" comment on a post. */
export function setBestAnswer(payload) {
    var _a = serializer(_setBestAnswerRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setBestAnswerResponse, {}).fromJSON;
    function __setBestAnswer(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.post',
            method: 'PUT',
            methodFqn: 'com.wixpress.npm.communities.forum.api.PostManagementService.SetBestAnswer',
            url: resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl({
                protoPath: '/v1/posts/{postId}/best-answer',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setBestAnswer.fromReq = fromReq;
    __setBestAnswer.__isAmbassador = true;
    return __setBestAnswer;
}
/** Removes "best answer" from a comment on a post. */
export function removeBestAnswer(payload) {
    var _a = serializer(_removeBestAnswerRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeBestAnswerResponse, {}).fromJSON;
    function __removeBestAnswer(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.post',
            method: 'DELETE',
            methodFqn: 'com.wixpress.npm.communities.forum.api.PostManagementService.RemoveBestAnswer',
            url: resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl({
                protoPath: '/v1/posts/{postId}/best-answer',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeBestAnswer.fromReq = fromReq;
    __removeBestAnswer.__isAmbassador = true;
    return __removeBestAnswer;
}
/** Pins post */
export function pinPost(payload) {
    var _a = serializer(_pinPostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_pinPostResponse, {}).fromJSON;
    function __pinPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.post',
            method: 'PUT',
            methodFqn: 'com.wixpress.npm.communities.forum.api.PostManagementService.PinPost',
            url: resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl({
                protoPath: '/v1/posts/{postId}/pin',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __pinPost.fromReq = fromReq;
    __pinPost.__isAmbassador = true;
    return __pinPost;
}
/** Unpins post */
export function unpinPost(payload) {
    var _a = serializer(_unpinPostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unpinPostResponse, {}).fromJSON;
    function __unpinPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.post',
            method: 'DELETE',
            methodFqn: 'com.wixpress.npm.communities.forum.api.PostManagementService.UnpinPost',
            url: resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl({
                protoPath: '/v1/posts/{postId}/unpin',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unpinPost.fromReq = fromReq;
    __unpinPost.__isAmbassador = true;
    return __unpinPost;
}
/** Adds reaction to post */
export function addReaction(payload) {
    var _a = serializer(_addReactionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addReactionResponse, {}).fromJSON;
    function __addReaction(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.post',
            method: 'PUT',
            methodFqn: 'com.wixpress.npm.communities.forum.api.PostManagementService.AddReaction',
            url: resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl({
                protoPath: '/v1/posts/{postId}/react',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addReaction.fromReq = fromReq;
    __addReaction.__isAmbassador = true;
    return __addReaction;
}
/** Removes reaction from post */
export function removeReaction(payload) {
    var _a = serializer(_removeReactionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeReactionResponse, {}).fromJSON;
    function __removeReaction(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.post',
            method: 'DELETE',
            methodFqn: 'com.wixpress.npm.communities.forum.api.PostManagementService.RemoveReaction',
            url: resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl({
                protoPath: '/v1/posts/{postId}/react',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeReaction.fromReq = fromReq;
    __removeReaction.__isAmbassador = true;
    return __removeReaction;
}
/** Report post */
export function reportPost(payload) {
    var _a = serializer(_reportPostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reportPostResponse, {}).fromJSON;
    function __reportPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.post',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.forum.api.PostManagementService.ReportPost',
            url: resolveComWixpressNpmCommunitiesForumApiPostManagementServiceUrl({
                protoPath: '/v1/posts/{postId}/report',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reportPost.fromReq = fromReq;
    __reportPost.__isAmbassador = true;
    return __reportPost;
}
//# sourceMappingURL=http.impl.js.map